import ci from './style.module.scss';

import { useRef, useEffect } from 'react';

export default function Select1({ label, value = '', children, name, onChange , required=false }) {
  const y = useRef();
  useEffect(() => {
    if (value) {
      y.current.value = value;
    }
  }, [value]);
  const co = () => {
    console.log('copied');
    y.current?.focus();
  };
  return (
    <>
      <label className={ci.label}>{label}</label>
      <div className={ci.c}>
        <select ref={y} name={name} onChange={onChange} required={required}>
          {children}
        </select>
        <div
          className={ci.e}
          onClick={() => {
            co();
          }}
        >
          <div className={ci.icon}></div>
        </div>
      </div>
    </>
  );
}
